import { OutputTechnology } from '@enmon/commons/lib/tools';
import { DefaultOptionType } from 'antd/lib/select';
import { IntlShape } from 'react-intl';
import { Nullable } from '@enmon/commons';
import { Commodity } from '@enmon/commons/lib/shared';
import { outputTechnologyTranslated } from '../../../../../components/Form/meter_details/messages';

export const getMeterMountTechnologySelectOptions = (
  commodity: Nullable<Commodity>,
  intl: IntlShape,
): DefaultOptionType[] => {
  if (!commodity) {
    console.warn('Received empty commodity: ', commodity);
    return [];
  }
  return Object.values(OutputTechnology).map(value => ({
    label: intl.formatMessage(outputTechnologyTranslated[value]),
    value,
  }));
};
